import type { AccountOption } from "@/components/agents/tasks/task-account-menu";
import { appLevelAssetUrl } from "@/lib/supabase/public-storage";

function onboardingLogoUrl(filename: string) {
  return appLevelAssetUrl(`on-boarding-logos/${filename}`);
}

/** Demo customer accounts for the onboarding kanban — names/logos from Figma 786:14102. */
export const DEMO_KANBAN_ACCOUNTS: AccountOption[] = [
  {
    id: "skims",
    name: "Skims",
    domain: "skims.com",
    logoUrl: onboardingLogoUrl("skims.png"),
  },
  {
    id: "sony",
    name: "Sony",
    domain: "sony.com",
    logoUrl: onboardingLogoUrl("sony.png"),
  },
  {
    id: "ikea",
    name: "IKEA",
    domain: "ikea.com",
    logoUrl: onboardingLogoUrl("ikea.png"),
  },
  {
    id: "clay",
    name: "Clay",
    domain: "clay.com",
    logoUrl: onboardingLogoUrl("clay.png"),
  },
  {
    id: "glossier",
    name: "Glossier",
    domain: "glossier.com",
    logoUrl: onboardingLogoUrl("glossier.png"),
  },
  {
    id: "superpower",
    name: "Superpower",
    domain: "superpower.com",
    logoUrl: onboardingLogoUrl("superpower.png"),
  },
  {
    id: "kalshi",
    name: "Kalshi",
    domain: "kalshi.com",
    logoUrl: onboardingLogoUrl("kalshi.png"),
  },
];

export const DEMO_KANBAN_ACCOUNT_BY_ID = Object.fromEntries(
  DEMO_KANBAN_ACCOUNTS.map((account) => [account.id, account]),
) as Record<string, AccountOption>;

export function demoKanbanAccount(accountId: string): AccountOption | null {
  return DEMO_KANBAN_ACCOUNT_BY_ID[accountId] ?? null;
}
